import {Component, OnInit, Injector, AfterViewInit, Input, OnDestroy} from '@angular/core';
import {AppComponentBase} from '../../../services/AppComponentBase';
import {Options} from 'ng5-slider';
import {ITIScanRule, ITIRange, tiWizardSaved} from '../interfaces/scanner.interfaces';
import {ScannerPrimarySearchList} from '../interfaces/scanner.enums';


@Component({
    selector: 'app-scanner-tiWizardSelector',
    template: require('./scanner-tiWizardSelector.component.html'),
    styles: [require('./scanner-tiWizardSelector.component.css')]
})
export class ScannerTiWizardSelectorComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {


    private _minValueMomentum: number = -30;
    public get minValueMomentum(): number {
        return this._minValueMomentum;
    }
    public set minValueMomentum(value: number) {
        this._minValueMomentum = value;
        this.updateScanRule();
    }


    private _maxValueMomentum: number = 30;
    public get maxValueMomentum(): number {
        return this._maxValueMomentum;
    }
    public set maxValueMomentum(value: number) {
        this._maxValueMomentum = value;
        this.momentumRange = {from: this.minValueMomentum, to: this.maxValueMomentum};
        this.updateScanRule();
    }

    public momentumRange: ITIRange = {from: this.minValueMomentum, to: this.maxValueMomentum};

    private _minValueVolatility: number = 50;
    public get minValueVolatility(): number {
        return this._minValueVolatility;
    }
    public set minValueVolatility(value: number) {
        this._minValueVolatility = value;
        this.updateScanRule();
    }

    private _maxValueVolatility: number = 100;
    public get maxValueVolatility(): number {
        return this._maxValueVolatility;
    }
    public set maxValueVolatility(value: number) {
        this._maxValueVolatility = value;
        this.volatilityRange = {from: this.minValueVolatility, to: this.maxValueVolatility};
        this.updateScanRule();
    }

    public volatilityRange: ITIRange = {from: this.minValueVolatility, to: this.maxValueVolatility};


    private _minValueBS: number = -30;
    public get minValueBS(): number {
        return this._minValueBS;
    }
    public set minValueBS(value: number) {
        this._minValueBS = value;
        this.updateScanRule();
    }


    private _maxValueBS: number = 30;
    public get maxValueBS(): number {
        return this._maxValueBS;
    }
    public set maxValueBS(value: number) {
        this._maxValueBS = value;
        this.bsRange = {from: this.minValueBS, to: this.maxValueBS};
        this.updateScanRule();
    }

    public bsRange: ITIRange = {from: this.minValueBS, to: this.maxValueBS};

    private _scanRule: ITIScanRule = {};
    public get scanRule(): ITIScanRule {
        return this._scanRule;
    }
    public set scanRule(value: ITIScanRule) {
        this._scanRule = value;
    }

    public updateScanRule() {




        this.scanRule.momentum = this.momentumEnabled ? this.momentumRange : undefined;
        this.scanRule.volatility = this.volatilityEnabled ? this.volatilityRange : undefined;
        this.scanRule.buyingselling = this.buyingandsellingEnabled ? this.bsRange : undefined;
        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
        this.allowScanProcess();
    }

    optionsVolatility: Options = {
        floor: 0,
        ceil: 150,
        step: 10,
        showTicks: false
    };

    optionsBS: Options = {
        floor: -100,
        ceil: 100,
        step: 10,
        showTicks: false,
        rightToLeft: true
    };

    optionsMomentum: Options = {
        floor: -100,
        ceil: 100,
        step: 10,
        showTicks: false,
        vertical: true
    };



    ngAfterViewInit(): void {

        let v = this.workspace.initLoadScan;
        if(v != null) {
            this.loadScanData(v);
            // this.workspace.initLoadScan = null;
        }

    }


    constructor(injector: Injector) {
        super(injector);

        this.workspace.globaGridMode.loadScannerRule.subscribe(v => {

            //  if(v.primary == ScannerPrimarySearchList.SCANNER_TIWIZARD)
            this.loadScanData(v)

        });

        this.workspace.globaGridMode.changeScannerSide.subscribe(v => {
            this.allowScanProcess();
        })

    }


    public _narrowScannerMode: boolean = false;

    @Input() public set narrowScannerMode(value: boolean) {
        this._narrowScannerMode = value;
        if(value == true) {
            this.workspace.scannerCurrentRule_Narrow = undefined;
        }
    }

    public get narrowScannerMode() {
        return this._narrowScannerMode;
    }

    public subscribers: any = {};
    ngOnDestroy() {
        //  this.subscribers.load.unsubscribe();
    }







    public loadScanData(v: any) {


        let loadScanData: tiWizardSaved = (!this.narrowScannerMode) ? <tiWizardSaved> v.savedData : <tiWizardSaved> v.savedDataSecondary;

        if(loadScanData.primary != ScannerPrimarySearchList.SCANNER_TIWIZARD) {
            return
        }

        this.workspace.scannerSearch_period = loadScanData.period
        if(loadScanData.rule.momentum) {
            this.momentumEnabled = true;
            this.minValueMomentum = loadScanData.rule.momentum.from
            this.maxValueMomentum = loadScanData.rule.momentum.to
        }
        else {
            this.momentumEnabled = false;
        }

        if(loadScanData.rule.volatility) {
            this.volatilityEnabled = true;
            this.minValueVolatility = loadScanData.rule.volatility.from
            this.maxValueVolatility = loadScanData.rule.volatility.to
        }
        else {
            this.volatilityEnabled = false;
        }

        if(loadScanData.rule.buyingselling) {
            this.buyingandsellingEnabled = true;
            this.minValueBS = loadScanData.rule.buyingselling.from
            this.maxValueBS = loadScanData.rule.buyingselling.to
        }
        else {
            this.buyingandsellingEnabled = false;
        }
        this.workspace.canSelectedSavedScanUpdate = false;
        this.workspace.allowScanProcess = true;
    }


    private _momentumEnabled: boolean = false;
    public get momentumEnabled(): boolean {
        return this._momentumEnabled;
    }
    public set momentumEnabled(value: boolean) {
        this._momentumEnabled = value;
        this.updateScanRule();
    }


    private _volatilityEnabled: boolean = false;
    public get volatilityEnabled(): boolean {
        return this._volatilityEnabled;
    }
    public set volatilityEnabled(value: boolean) {
        this._volatilityEnabled = value;
        this.updateScanRule();
    }

    private _buyingandsellingEnabled: boolean = false;
    public get buyingandsellingEnabled(): boolean {
        return this._buyingandsellingEnabled;
    }
    public set buyingandsellingEnabled(value: boolean) {
        this._buyingandsellingEnabled = value;
        this.updateScanRule();
    }






    ngOnInit() {

        this.allowScanProcess();
    }






    public allowScanProcess() {

        if(this.workspace.scannerSearch_period != "NO") {
            if(this.buyingandsellingEnabled || this.volatilityEnabled || this.momentumEnabled) {
                this.workspace.allowScanProcess = true;
            }
            else {
                this.workspace.allowScanProcess = false;
            }

        }
        else {
            this.workspace.allowScanProcess = false;
        }

    }




    public onShown(e: any) {

    }





}


